<template>
  <div>
    <div class="ml-md-3 mt-md-3 mb-3 search-wrapper">
      <div>
        <label class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0">
          所在地
        </label>
        <div class="d-md-inline text-left">
          <select
            class="d-inline form-control col-4 col-md-2 ml-md-2"
            v-model="searchCond.TODO_CD"
            @change="changePref"
          >
            <option
              v-for="pref in prefList"
              :value="pref.value"
              :key="pref.value"
            >
              {{ pref.text }}
            </option>
          </select>
          <select
            class="d-inline form-control col-7 col-md-3 ml-2"
            @change="changeCity"
            v-model="searchCond.SHIKU_CD"
            :disabled="!cityList.length"
          >
            <option
              v-for="city in cityList"
              :value="city.value"
              :key="city.value"
            >
              {{ city.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="ml-md-3 mx-auto mb-md-2">
      <label class="d-inline col-3 col-md-2 col-lg-2 px-0">場所名：</label>
      <span v-if="isMobile" class="bold blue col-8 col-md-9 px-0">
        {{
          !selectedItem ? '選択なし' : _omitText(selectedItem.HIKINO_MEI, 22)
        }}
      </span>
      <span v-else class="bold blue col-8 col-md-9 px-0">
        {{
          !selectedItem ? '選択なし' : _omitText(selectedItem.HIKINO_MEI, 28)
        }}
      </span>
    </div>
    <section id="order-auction">
      <div v-if="isLoading" class="spinner my-5">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <md-table
          v-if="recordList.length"
          class="black-svg h-300 checkbox"
          v-model="recordList"
          md-sort="HIKINO_MEI"
          md-sort-order="asc"
          md-card
          md-fixed-header
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click="selected(item)"
            :class="{ selected: selectedItem && item.ID === selectedItemId }"
          >
            <md-table-cell v-if="!isMobile" md-label="">
              <input type="radio" :value="item.ID" v-model="selectedItemId" />
            </md-table-cell>
            <md-table-cell md-label="場所名" md-sort-by="HIKINO_MEI">
              <span v-if="!isMobile">{{ omitText(item.HIKINO_MEI, 45) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">場所名</p>
                <p class="col-9 p-0">{{ _omitText(item.HIKINO_MEI, 18) }}</p>
              </div>
            </md-table-cell>
            <md-table-cell md-label="住所" md-sort-by="ADDRESS">
              <span v-if="!isMobile">{{ omitText(item.ADDRESS, 45) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">住所</p>
                <p class="col-9 p-0">{{ _omitText(item.ADDRESS, 18) }}</p>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center my-5 bold">該当データがありません。</div>
      </div>
    </section>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin' // テーブルレコードの高さ(px)
import Store from '@/store/index.js'
import _ from 'lodash'
const DATA_KBN = 'FAVORITE'
export default {
  name: 'Favorite',
  props: {
    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** 画面表示フラグ */
    isActive: {
      type: Boolean,
      default: false,
    },

    form: {
      type: Object,
      default: null,
    },

    /** エラーが存在するか取得するフラグ */
    isInvalidActive: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [Mixin],
  data: () => ({
    /** 編集データ */
    editedItem: null,
    /** ローディングフラグ */
    isLoading: false,

    /** 市区町村リスト */
    cityList: [],

    /** 検索条件 */
    searchCond: {
      TODO_CD: null,
      SHIKU_CD: '',
      NAME: null,
    },

    /** 登録済みテーブル一覧 */
    recordList: [],

    /** 選択データ*/
    selectedItem: null,

    /** 選択データID */
    selectedItemId: null,

    /** オークション表示フラグ */
    isAAFlg: 0,

    /** 画面を1度でも表示したか */
    isActivated: false,
  }),

  created: function () {
    this.search()
  },

  methods: {
    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.searchCond.TODO_CD) return
      Store.dispatch('address/getCityList', this.searchCond.TODO_CD).then(
        () => {
          const cityList = _.cloneDeep(Store.state.address.cityList)
          cityList.unshift({
            value: '',
            text: '未選択',
          })
          this.cityList = cityList
        }
      )
    },

    /**
     * お気に入り引取先選択
     * @param  {Object} item 選択した登録済み
     */
    selected(item) {
      this.selectedItem = item
      this.selectedItemId = item.ID
      this.deform(item)
      this.isAAFlg = Number(item.HIKINO_AA_CD) ? 1 : 0
    },

    /** データを変換する */
    deform(item) {
      this.form.FAVORITE_ID = item.ID
      this.form.AA_KAISAI_BI = null
      this.form.AA_CD = item.HIKINO_AA_SHIKI_CD
      this.form.AA_ID = item.HIKINO_AA_CD
      this.form.TOROKUBAYO_KO_ID = null
      this.form.YUBIN1 = item.HIKINO_YUBIN1
      this.form.YUBIN2 = item.HIKINO_YUBIN2
      this.form.TODO_CD = item.HIKINO_TODO_CD
      this.form.TODO_MEI = item.HIKINO_TODO_MEI
      this.form.SHIKU_CD = item.HIKINO_SHIKU_CD
      this.form.SHIKU_MEI = item.HIKINO_SHIKU_MEI
      this.form.BANCHI = item.HIKINO_BANCHI
      this.form.MEI = item.HIKINO_MEI
      this.form.TEL = item.HIKINO_TEL
      this.form.YUSO_KBN = item.HIKINO_YUSO_KBN
      this.form.HCB_ZOKUSEI_CD = item.HIKINO_HCB_ZOKUSEI_CD
      this.form.LANDMARK_KBN = item.HIKINO_LANDMARK_KBN
      this.form.TANTO_MEI = item.HIKINO_TANTO_MEI
      this.form.TANTO_TEL = item.HIKINO_TANTO_TEL
      this.form.TEIKYU_BI = item.HIKINO_TEIKYU_BI
      this.form.EIGYO_KAISI_JIKAN = item.HIKINO_EIGYO_KAISI_JIKAN
      this.form.EIGYO_SYURYO_JIKAN = item.HIKINO_EIGYO_SYURYO_JIKAN
      this.form.HANNYUSYUTU_JIKAN = null
      this.form.IS_PERSONAL = item.HIKINO_YUSO_KBN === 'kojin'
    },

    /** 入力データを初期化する */
    reset() {
      this.selectedItem = null
      this.selectedItemId = null
      this.isAAFlg = 0
      this.$emit('reset', DATA_KBN)
    },

    /** 検索する */
    search() {
      this.isLoading = true
      this.reset()
      return Store.dispatch('order/getOkiniiri', this.searchCond).then(
        (list) => {
          this.recordList = list
          this.isLoading = false
        }
      )
    },

    /** 都道府県変更 */
    changePref() {
      this.cityList = []
      this.searchCond.SHIKU_CD = ''
      this.search()
      this.getCityList()
    },

    /** 市区町村変更 */
    changeCity() {
      this.search()
    },

    /** 入力状況を再現する */
    async revival() {
      const cond = this._searchCond
      this.searchCond.TODO_CD = cond.TODO_CD
      this.searchCond.SHIKU_CD = cond.SHIKU_CD
      this.getCityList()
      await this.search()
      const item = this.recordList.filter((v) => v.ID === cond.ID)[0]
      if (item) this.selected(item)
      this.callSetIsAAflg()
    },

    /** オークションフラグの設定を親に伝える */
    callSetIsAAflg() {
      this.$emit('setIsAAFlg', this.isAAFlg, DATA_KBN)
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading(val) {
      this.$emit('loaded', val, DATA_KBN)
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond) this.revival()
        else await this.search()
        this.$emit('searched', DATA_KBN)
      }
    },

    /** エラーが存在するか取得するフラグ監視 */
    isInvalidActive(val) {
      if (val) {
        this.$emit('setInvalid', this.selectedItem ? false : true)
      }
    },

    /** オークションフラグ監視 */
    isAAFlg(val) {
      this.callSetIsAAflg()
    },

    /** 画面表示フラグ監視 */
    isActive(val) {
      if (val && !this.isActivated) {
        this.search()
        this.isActivated = true
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.color-on
  background: $baseBlueColor
  color: #fff
.color-off
  background: #fff
  color: $baseBlackColor
.bottom-1
  margin-bottom: 1rem
.yusosaki-mei
  height: 56px

th:nth-child(1)
  width: 50px !important
td:nth-child(1)
  width: 50px !important
.selected
  background: $baseBlueColor
  color: #fff
</style>



// WEBPACK FOOTER //
// src/components/trial/Favorite.vue